import React from "react";
import Hero from "@/components/Hero";
import FAQ from "@/components/FAQ";
import BookingCTA from "@/components/BookingCTA";
import Marquee from "@/components/Marquee";
import {
    EditorialSplit,
    Manifesto,
    BenefitsGrid,
    DualCallout,
    RelatedLinks,
} from "@/components/Editorial";

/**
 * ServicePage — reusable editorial layout for service pages.
 * `data` shape:
 * {
 *   hero: { eyebrow, title[], subtitle, imgD, imgM },
 *   intro: { number, eyebrow, title, body[] }  // Manifesto
 *   how:   { number, eyebrow, title, body[], image, reverse? }  // EditorialSplit
 *   scope: { number, eyebrow, title, body[], image, reverse? }  // optional
 *   benefits: { eyebrow, title, subtitle, items: [{title, body}] }
 *   whenAdvised: { eyebrow, title, subtitle, cards: [{title, list?, body?}] }
 *   whyUs: { number, eyebrow, title, body[], image, reverse? }
 *   marquee?: string[]
 *   faq: [{q,a}],
 *   related: [{label, to}]
 *   ctaTitle, ctaSubtitle
 * }
 */
export default function ServicePage({ data }) {
    return (
        <>
            <Hero
                eyebrow={data.hero.eyebrow}
                title={data.hero.title}
                subtitle={data.hero.subtitle}
                subtitleMobile={data.hero.subtitleMobile}
                imgDesktop={data.hero.imgD}
                imgMobile={data.hero.imgM}
                primaryCta={{ label: "Prenota un appuntamento", href: "/contatti" }}
                secondaryCta={{ label: "Richiedi informazioni", href: "/contatti" }}
            />

            {data.marquee && null}

            <Manifesto {...data.intro} accent="bg-ivory" />

            <EditorialSplit
                {...data.how}
                accentBg="bg-blush/35"
            />

            {data.scope && (
                <EditorialSplit
                    {...data.scope}
                    reverse
                    accentBg="bg-ivory-warm"
                />
            )}

            <BenefitsGrid {...data.benefits} accent="bg-ivory" />

            {data.whenAdvised && <DualCallout {...data.whenAdvised} />}

            <EditorialSplit
                {...data.whyUs}
                accentBg="bg-rose-powder/40"
            />

            <BookingCTA
                eyebrow="Prenota"
                title={data.ctaTitle}
                subtitle={data.ctaSubtitle}
            />

            <FAQ items={data.faq} />

            {data.related && <RelatedLinks items={data.related} />}
        </>
    );
}
